import { render } from "./DeleteMenuModal.vue?vue&type=template&id=5d1dfb7c"
import script from "./DeleteMenuModal.vue?vue&type=script&lang=js"
export * from "./DeleteMenuModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__